export default __webpack_public_path__ + "d4795b67627e12b2dcf753d7ff454b2c.png";